/*
 * Color Visualizer
 */
'use strict';

jQuery($ => {

    $('.gecko-panel-photo-gallery .swiper-container').each((i, ui) => {
        const swiper = new Swiper($(ui), {
            spaceBetween: 32,
            slidesPerView: 'auto',

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    });

});
